import { filter, map, Observable, of, take } from "rxjs";
import { Select } from "@ngxs/store";
import { FeatureToggleState } from "src/app/core/feature-toggle/state/feature-toggle.state";
import { Inject, Injectable, PLATFORM_ID } from "@angular/core";
import { isPlatformBrowser } from "@angular/common";
import { CanActivate, Router } from "@angular/router";

@Injectable({ providedIn: "root" })
export class MaintenanceGuard implements CanActivate {
  @Select(FeatureToggleState.isInMaintenance)
  isInMaintenance$!: Observable<boolean>;

  constructor(
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: object,
  ) {}

  canActivate(): Observable<boolean> {
    // During SSR/prerender there is no feature toggle data - allow render
    if (!isPlatformBrowser(this.platformId)) {
      return of(true);
    }

    return this.isInMaintenance$.pipe(
      filter((isMaintenance) => isMaintenance !== null),
      take(1),
      map((isMaintenance) => {
        if (isMaintenance) {
          this.router.navigate(["/maintenance"]);
          return false;
        }
        return true;
      })
    );
  }
}
